module.exports = "/images/salesflow-logo-gray.svg?173dfb5de4b22aeae2c97d4b3f1bc1ef";